__turbopack_context__.v({
  "loading": "H-lxRq_loading",
  "product-results": "H-lxRq_product-results",
  "product-results__message": "H-lxRq_product-results__message",
  "product-results__message--success": "H-lxRq_product-results__message--success",
  "product-results__message--warn": "H-lxRq_product-results__message--warn",
  "product-results__message-icon": "H-lxRq_product-results__message-icon",
});
